import { Pipe } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'datum'
})
export class DatumPipe extends DatePipe {
  transform(value: any): any {
    return super.transform(value, 'mediumDate', '', 'de-CH');
  }
}
